module.exports = __webpack_public_path__ + "img/gold_vip_invalid.a5564614.png";